<template>
  <div
    :class="[
      $style.skeleton,
      // Light theme
      'from-gray-100 via-gray-200 to-gray-100',
      // Dark theme
      'dark:from-navy-800 dark:via-navy-600 dark:to-navy-800',
    ]"
    class="bg-gradient-to-r from-25% via-50% to-75%"
  >
    <slot />
  </div>
</template>
<style module>
@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.skeleton {
  background-size: 200% 100%;
  animation: loading 3s infinite ease-in-out;
  will-change: background-position;
}
@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}
</style>
